import React, { PropTypes } from 'react';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import Logo from '../../../assets/images/login/Nitro_logo.png';
import { media } from '../../../utils/style-utils';
import auth0Login from '../../../utils/auth0/login';

const Bar = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 34px;

  ${media.mobile`
    flex-direction: column-reverse;
    padding: 12px 26px;
  `};
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
`;

const LogoImg = styled.img`
  ${media.mobile`
    margin: 30px 0 10px;
  `};
`;

const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;

  ${media.mobile`
    justify-content: center;
    flex-wrap: wrap;
  `};
`;

const StyledButton = styled(FlatButton)`
  &:not(:first-of-type) {
    margin-left: 27px !important;

    ${media.mobile`
      margin-left: 13px!important;
      margin-right: 13px!important;
    `};
  }

  ${media.mobile`
    margin: 0 13px!important;
  `};
`;

const StyledLoginButton = styled(StyledButton)`
  color: #616161 !important;

  &:hover {
    color: #fff !important;
  }
`;

const ButtonLabel = styled.span`
  font-size: 11px;
  font-family: ${props => props.theme.font.bold};
`;

class LoginButtons extends React.Component {
  // eslint-disable-next-line class-methods-use-this
  onScroll(id) {
    const el = window.document.getElementById(id);
    el.scrollIntoView({ behavior: 'smooth' });
  }

  render() {
    return (
      <Bar>
        <LogoContainer>
          <LogoImg src={Logo} alt="Nitro" />
        </LogoContainer>
        <ButtonContainer>
          <StyledButton
            id="whyNitroButton"
            onClick={() => this.onScroll(this.props.whyNitroElId)}
            disableTouchRipple
            style={{ color: 'white' }}
          >
            <ButtonLabel>WHY NITRO</ButtonLabel>
          </StyledButton>
          <StyledButton
            id="registerButton"
            onClick={() => this.onScroll(this.props.demoElId)}
            disableTouchRipple
            style={{ border: '2px solid white', color: 'white' }}
          >
            <ButtonLabel>REGISTER</ButtonLabel>
          </StyledButton>
          <StyledLoginButton
            id="loginButton"
            onClick={() => auth0Login()}
            disableTouchRipple
            style={{ color: '#616161' }}
            backgroundColor="white"
          >
            <ButtonLabel>LOGIN</ButtonLabel>
          </StyledLoginButton>
        </ButtonContainer>
      </Bar>
    );
  }
}

LoginButtons.propTypes = {
  whyNitroElId: PropTypes.string.isRequired,
  demoElId: PropTypes.string.isRequired
};

export default LoginButtons;



// WEBPACK FOOTER //
// ./src/features/login/login-buttons/LoginButtons.js